import StudioIcon from "@/assets/icons/studio-logo.svg";
import StageIcon from "@/assets/icons/stage-logo.svg";
import React from "react";
import { IClipsIcon, IonIcon, LiveIcon, } from "../presentation/components/icons";
import GTNIcon from "@/assets/icons/gtn-icon.svg";
export var productIconByCode = {
    studio: React.createElement(StudioIcon, null),
    rc1: React.createElement(StudioIcon, null),
    rc2: React.createElement(StudioIcon, null),
    stage: React.createElement(StageIcon, null),
    "global talent network": React.createElement(GTNIcon, null),
    ion: React.createElement(IonIcon, null),
    live: React.createElement(LiveIcon, null),
    iclips: React.createElement(IClipsIcon, null),
};
